// Hand-over from a report page to the print route (/print/deep-analysis).
//
// The ticket carries the same data the on-screen report already holds, so the
// print tab renders without a second fetch and every caller (live page, report
// history, Branch Radar) prints the same way. localStorage is the one channel a
// freshly opened tab can read synchronously; the key is one-shot — the print tab
// moves it into its own sessionStorage, so a reload there still works while the
// shared store never keeps a report around.
const PREFIX = "landhep_print::";
const TTL_MS = 60 * 60 * 1000;

function purgeStale() {
  try {
    const now = Date.now();
    for (let i = localStorage.length - 1; i >= 0; i--) {
      const k = localStorage.key(i);
      if (!k || !k.startsWith(PREFIX)) continue;
      let createdAt = 0;
      try { createdAt = JSON.parse(localStorage.getItem(k) || "{}").createdAt || 0; } catch { /* drop it */ }
      if (now - createdAt > TTL_MS) localStorage.removeItem(k);
    }
  } catch { /* storage unavailable — nothing to purge */ }
}

// Must be called synchronously from the click handler: window.open outside a
// user gesture is what pop-up blockers stop.
export function openDeepAnalysisPrint(ticket) {
  purgeStale();
  const key = `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 8)}`;
  try {
    localStorage.setItem(PREFIX + key, JSON.stringify({ ...ticket, createdAt: Date.now() }));
  } catch {
    throw new Error("Laporan terlalu besar untuk disiapkan di browser ini.");
  }
  const w = window.open(`/print/deep-analysis?k=${key}`, "_blank");
  if (!w) {
    localStorage.removeItem(PREFIX + key);
    throw new Error("Pop-up diblokir. Izinkan pop-up untuk situs ini, lalu coba lagi.");
  }
}

export function readPrintTicket(key) {
  if (!key) return null;
  const k = PREFIX + key;
  try {
    let raw = sessionStorage.getItem(k);
    if (!raw) {
      raw = localStorage.getItem(k);
      if (raw) { localStorage.removeItem(k); sessionStorage.setItem(k, raw); }
    }
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}
